module.exports = __webpack_public_path__ + "img/clint-mckoy.7a482f6d.jpg";